import { Provider } from 'react-redux';
import { store } from './store';

export const ReduxProvider = ({ children }: React.PropsWithChildren<{}>) => {
	return <Provider store={store}>{children}</Provider>;
};
